import 'react-toastify/dist/ReactToastify.css';
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { Main } from './components/Main/Main';
import { GlobalStyle } from './styles/global';
function App() {
	return (
		<>
			<GlobalStyle />
			<Header />
			<Main />
			<Footer />
		</>
	);
}

export default App;
